/**
 * GPU pool readiness API client — GET /admin/gpu/readiness on tacosai-admin-api.
 * Checks every online comfyui-img host (through the gateway) for the nodes +
 * models the studio production fragments need.
 */
import { request } from './client.js';

export interface HostReadiness {
  label: string;
  datacenter: string | null;
  reachable: boolean;
  missingNodes: string[];
  missingModels: string[];
  error?: string;
}
export interface FragmentReadiness {
  template: string;
  ready: boolean;
  missingNodes: string[];
  missingModels: string[];
}
export interface GpuReadiness {
  checkedAt: string;
  allReady: boolean;
  requiredNodes: number;
  requiredModels: number;
  hosts: HostReadiness[];
  fragments: FragmentReadiness[];
  gatewayError: string | null;
}

export function fetchGpuReadiness(): Promise<GpuReadiness> {
  return request<GpuReadiness>({ method: 'GET', url: '/admin/gpu/readiness' });
}
